import * as React from 'react';
import { SVGProps, memo } from 'react';

/**
 * НЕ РЕДАКТИРОВАТЬ
 *
 * Этот файл создан автоматически с помощью svgr
 *
 * Подробнее, как работать с иконками:
 * @see https://lvtv.me/icons
 */
const SvgBonus = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 16" {...props}>
    <g fill="none" fillRule="evenodd" stroke="#000">
      <path d="M6.573 2.24C5.833.93 5.25.658 4.824 1.424c-.426.765-1.606 3.1-3.537 7.002-.464.69-.365 1.241.297 1.653.187 1.628.351 5.12 4.989 5.12 3.092 0 4.485-1.965 4.18-5.895.002-.585.427-.878 1.274-.878M1 8.562c3.73-.75 7.063-.75 10 0" />
      <path d="M17.454 2.24c.74-1.31 1.322-1.582 1.749-.816.426.765 1.606 3.1 3.537 7.002.464.69.365 1.241-.297 1.653-.187 1.628-.351 5.12-4.989 5.12-3.092 0-4.485-1.965-4.18-5.895-.002-.585-.427-.878-1.274-.878m11 .136c-3.73-.75-7.063-.75-10 0" />
    </g>
  </svg>
);
const Memo = memo(SvgBonus);
export default Memo;
